import React from 'react';
import charityIcon from '../Images/CharityIcon.png';

const COLORS = {
  cardBg: '#153F43',
  text: '#FFFFFF',
  muted: '#AABEC0',
  line: 'rgba(255,255,255,0.1)',
  badgeBg: 'rgba(255,255,255,0.08)',
  badgeRing: 'rgba(166,213,176,0.45)',
  heroBg: 'rgba(255,255,255,0.08)',
  orange: '#FF8717',
};

export function normalizeHeroMode(value) {
  return value === 'graphic' ? 'graphic' : 'photo';
}

export function defaultHeroModeForImageMeta(meta = {}) {
  const width = Number(meta.width || meta.naturalWidth || 0);
  const height = Number(meta.height || meta.naturalHeight || 0);
  if (width > 0 && height > 0) {
    return width / height >= 1.35 ? 'photo' : 'graphic';
  }
  return normalizeHeroMode(meta.heroMode);
}

export default function CauseConsumerPreview({
  name,
  impactLabel = 'Local Impact',
  missionText,
  whySupportText,
  heroUrl,
  heroMode = 'photo',
  categoryLabel = 'Cause',
  showSupportButton = false,
  style,
}) {
  const mode = normalizeHeroMode(heroMode);
  const isGraphic = mode === 'graphic';

  return (
    <div style={{ ...styles.wrap, ...style }}>
      <div style={styles.headerRow}>
        <div style={styles.categoryBadge} title={categoryLabel || 'Cause category'}>
          <img src={charityIcon} alt="" aria-hidden="true" style={styles.categoryIcon} />
        </div>
        <div style={styles.titleColumn}>
          <div style={styles.name}>{name || 'Organization Name'}</div>
          <div style={styles.impact}>{impactLabel || 'Local Impact'}</div>
        </div>
      </div>

      <div style={styles.divider} />

      <section>
        <div style={styles.sectionLabel}>Mission</div>
        <div style={styles.missionText}>
          {missionText || 'Use a short description to quickly tell supporters who you are.'}
        </div>
      </section>

      <div
        style={{
          ...styles.heroFrame,
          ...(isGraphic ? styles.graphicHeroFrame : null),
        }}
      >
        {heroUrl ? (
          <img
            src={heroUrl}
            alt=""
            style={isGraphic ? styles.graphicHeroImage : styles.photoHeroImage}
          />
        ) : (
          <div style={styles.heroFallback}>Hero image preview</div>
        )}
      </div>

      <div style={styles.divider} />

      <div style={styles.whyText}>
        {whySupportText || 'Share the impact supporters make and why this cause matters.'}
      </div>

      {showSupportButton ? (
        <button type="button" style={styles.supportButton}>Support</button>
      ) : null}
    </div>
  );
}

const styles = {
  wrap: {
    background: COLORS.cardBg,
    color: COLORS.text,
    fontFamily: 'Helvetica, Arial, sans-serif',
    padding: 24,
    boxSizing: 'border-box',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  categoryBadge: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    border: `1.5px solid ${COLORS.badgeRing}`,
    background: COLORS.badgeBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
  },
  categoryIcon: {
    width: 34,
    height: 34,
    objectFit: 'contain',
    filter: 'brightness(0) invert(1)',
  },
  titleColumn: {
    minWidth: 0,
    flex: 1,
  },
  name: {
    fontSize: 22,
    lineHeight: 1.18,
    fontWeight: 700,
    letterSpacing: 0.3,
    overflowWrap: 'anywhere',
  },
  impact: {
    color: '#CBD4DC',
    fontSize: 14,
    fontWeight: 500,
    marginTop: 4,
  },
  divider: {
    height: 1,
    background: COLORS.line,
    margin: '16px 0',
  },
  sectionLabel: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 12,
  },
  missionText: {
    color: COLORS.muted,
    fontSize: 15,
    lineHeight: '24px',
    overflowWrap: 'anywhere',
  },
  heroFrame: {
    width: '100%',
    aspectRatio: '1.58 / 1',
    borderRadius: 8,
    overflow: 'hidden',
    background: 'rgba(255,255,255,0.06)',
    margin: '16px 0',
  },
  graphicHeroFrame: {
    aspectRatio: '1 / 1',
    padding: 10,
    background: COLORS.heroBg,
  },
  photoHeroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  graphicHeroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
  heroFallback: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(255,255,255,0.6)',
    fontSize: 13,
  },
  whyText: {
    color: COLORS.muted,
    fontSize: 15,
    lineHeight: '24px',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  },
  supportButton: {
    width: '75%',
    minWidth: 180,
    display: 'block',
    margin: '24px auto 0',
    border: 0,
    borderRadius: 8,
    padding: '13px 18px',
    color: '#fff',
    fontSize: 17,
    fontWeight: 700,
    background: COLORS.orange,
  },
};
